import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of, shareReplay } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Categoria } from '../models/vacante.model';

interface CategoriaApi {
  id: string;
  idCategoria: number;
  nombre: string;
  slug: string;
  icono: string;
  activo: boolean;
}

@Injectable({ providedIn: 'root' })
export class CategoriaService {
  private http = inject(HttpClient);
  private url = `${environment.apiBaseUrl}/public/categories`;
  private cache$?: Observable<Categoria[]>;

  /** Catálogo real de categorías (id/nombre/slug/icono), cacheado en memoria. */
  listar(): Observable<Categoria[]> {
    if (!this.cache$) {
      this.cache$ = this.http.get<{ categories: CategoriaApi[] }>(this.url).pipe(
        map((res) =>
          (res.categories ?? [])
            .filter((c) => c.activo !== false)
            .map((c) => ({ id: c.idCategoria, nombre: c.nombre, icono: c.icono, slug: c.slug }))
        ),
        catchError(() => of([] as Categoria[])),
        shareReplay(1)
      );
    }
    return this.cache$;
  }
}
